import "./style.css";
import Modal from "@/components/Modal";

export default class BookValuationSuccessModal extends Modal {
  static selector = ".valuation-success-modal";

  constructor(block) {
    super(block);

    this.block = block;
  }
}
